<script setup>
import AddSiteDialog from "../components/AddSiteDialog.vue";
import { useFetch } from "vutil";
import { ref } from "vue";

const numbFmt = new Intl.NumberFormat("nb-NO", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

const { data, error } = useFetch("/api/site");
const add = ref(false);
</script>

<template>
	<div class="error">{{ error }}</div>
	<div v-if="data" class="list">
		<div v-if="data.length === 0">
			<h2>Klar til å tilby lading via ZEV?</h2>
			<p>Start med å opprette et ladested.</p>
			<p>Du kan legge til ett eller flere ladesteder – for eksempel hjemme, på hytta, i borettslag eller på jobb – og knytte flere ladere til hvert sted.</p>
		</div>
		<div v-for="site in data" :key="site.id" class="site">
			<div class="btns">
				<RouterLink class="ui-btn icon" :to="{ name: 'chargers', params: { id: site.id } }" title="Ladepunkter"><img class="icon-charging-station"></RouterLink>
				<RouterLink class="ui-btn icon" :to="{ name: 'payouts', params: { id: site.id } }" title="Utbetalinger"><img class="icon-file-invoice"></RouterLink>
				<RouterLink class="ui-btn icon" :to="{ name: 'sessions', params: { id: site.id } }" title="Historikk"><img class="icon-history"></RouterLink>
			</div>
			<h2><RouterLink :to="{ name: 'site', params: { id: site.id } }">{{ site.addr }}</RouterLink></h2>
			<div class="prices">
				<div>{{ numbFmt.format(site.price_el / 100) }} <i>kr/kWh</i></div>
				<div>{{ numbFmt.format(site.price_park / 100) }} <i>kr/time</i></div>
			</div>
		</div>
	</div>
	<button v-if="data" class="ui" @click="add = true">Opprett ladested</button>
	<footer><a href="/help" target="_blank">Her</a> finner du nyttige tips.</footer>
	<AddSiteDialog v-if="add" @close="add = false"/>
</template>
